import styled from 'styled-components';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { BREAKPOINTS } from 'admin/utils/breakpoints';

export const ModalWrapper = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${({ isDeleteModal }) => (isDeleteModal ? '540px' : '1096px')};
  max-height: 700px;
  overflow-y: auto;
  background: ${COLORS.white};
  border-radius: 12px;
  gap: ${({ isDeleteModal }) => (isDeleteModal ? 'unset' : '30px')};
  padding: ${({ isDeleteModal }) => (isDeleteModal ? '32px' : '48px')};

  @media only screen and ${BREAKPOINTS.laptop} {
    max-height: 500px;
  }
`;

export const CloseIcon = styled.img`
  cursor: pointer;
  position: absolute;
  right: 22px;
  top: 22px;
  width: 12px;
  height: 12px;
`;

export const ModalSampleField = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 30px;
  width: 100%;
  height: 46px;
  padding: 0 196px;

  .MuiInputBase-formControl {
    width: 610px !important;
  }

  [class*='MuiFormLabel-root']:not([class*='MuiInputLabel-shrink']) {
    top: -9px !important;
  }

  .Mui-focused {
    color: ${COLORS.mainColor} !important;
  }

  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.mainColor} !important;
  }
`;

export const InputWithLabel = styled(TextField)`
  width: 100%;

  .MuiInputBase-formControl {
    height: 36px !important;
    border-radius: 8px !important;
  }

  .material-ui-textfield {
    height: 36px !important;
    padding: unset;
    padding-left: 10px;
  }

  .MuiInputLabel-outlined {
    top: unset;
    color: ${COLORS.lightSilver} !important;
  }

  .Mui-focused {
    color: ${COLORS.mainColor} !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.lightSilver} !important;
  }
`;

export const SampleInput = styled.input`
  width: ${({ isLabel }) => (isLabel ? '196px' : '100%')};
  height: 36px;
  border-radius: 8px;
  padding-left: 10px;
  border: 1px solid #686868;
  color: ${COLORS.black};
  ${FONTS.font16};

  &.focus {
    border: 1px solid ${COLORS.mainColor};
  }
`;

export const InputPlaceholderLabel = styled.label`
  ${FONTS.font14};
  position: absolute;
  top: 10px;
  left: 220px;
  transition: 0.3s;
  opacity: 1;
  z-index: 20000;
  background: ${COLORS.white};

  &.focus {
    top: -8px;
  }
`;

export const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PasswordEye = styled.img`
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: ${({ isPasswordVisible }) => (isPasswordVisible ? '8px' : '10px')};
  width: 18px;
  height: 18px;
  z-index: 10;
`;

export const ModalSpan = styled.span`
  width: 136px;
  text-align: left;
`;

export const StyledSelect = styled(Select)`
  position: absolute;
  z-index: ${({ role }) => (role ? 12 : 10)};
  height: 36px;
  outline: none;
  ${FONTS.font16};
  color: ${COLORS.black};
  width: 620px;
  text-transform: capitalize;

  .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
    bottom: 22px !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 8px !important;
    border-color: ${COLORS.lightSilver} !important;
  }

  .react-select__control {
    background-color: ${COLORS.whiteLite} !important;
    outline: none !important;
    border-radius: 8px !important;
    border-color: ${COLORS.lightSilver};
  }

  .Mui-focused {
    color: ${COLORS.mainColor} !important;
  }

  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.mainColor} !important;
  }
`;

export const AddAnswer = styled.button`
  width: 172px;
  height: 46px;
  flex-shrink: 0;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  border-radius: 8px;
`;

export const SampleDiv = styled.div``;

export const SampleImage = styled.img`
  cursor: pointer;
`;

export const SaveButton = styled.button`
  flex-shrink: 0;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  width: 172px;
  height: 46px;
  border-radius: 8px;
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const CreateUserErrorMessage = styled.span`
  position: absolute;
  color: ${COLORS.red};
  top: 40px;
  left: 332px;
  ${FONTS.font12};
  ${FONT_FAMILY.FontRegular};
`;
